import PropTypes from 'prop-types'
import React from 'react'
import { Router, browserHistory, applyRouterMiddleware } from 'react-router'
import useScroll from 'react-router-scroll'
import IntlProvider from './IntlProvider'
import UnitProvider from './UnitProvider'
import { Provider } from 'react-redux'
import routes from '../../routes'

const propTypes = {
  store: PropTypes.object,
}

export function App ({ store }) {
  return (
    <Provider store={store}>
      <IntlProvider>
        <UnitProvider>
          <Router
            history={browserHistory}
            render={applyRouterMiddleware(useScroll())}
          >
            {routes}
          </Router>
        </UnitProvider>
      </IntlProvider>
    </Provider>
  )
}

App.propTypes = propTypes

export default App



// WEBPACK FOOTER //
// ./src/application/root/App.jsx